import { render, staticRenderFns } from "./heroProductForm.vue?vue&type=template&id=1121d2f2&scoped=true"
import script from "./heroProductForm.vue?vue&type=script&lang=js"
export * from "./heroProductForm.vue?vue&type=script&lang=js"
import style0 from "./heroProductForm.vue?vue&type=style&index=0&id=1121d2f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1121d2f2",
  null
  
)

export default component.exports